import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core'
import { appConfig } from '../../../brands/_current/config/app-config'
import { interval } from 'rxjs'
import { takeUntil, tap } from 'rxjs/operators'

@Component({
  selector: 'app-cookie-disabled-page',
  templateUrl: './cookie-disabled-page.component.html',
  styleUrls: ['./cookie-disabled-page.component.scss'],
})
export class CookieDisabledPageComponent implements OnInit, OnDestroy {
  public helplineNumber = appConfig.core.helplineNumber

  private readonly onDestroy$ = new EventEmitter<void>()

  constructor() {}

  ngOnInit(): void {
    interval(3000)
      .pipe(
        tap(() => {
          if (navigator.cookieEnabled) {
            window.history.back()
          }
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.onDestroy$.emit()
  }
}
